import * as yup from 'yup';

type ErrorsType = {
  [key: string]: string;
};

const getErrors = (error: yup.ValidationError) => {
  return error.inner.reduce((acc, err) => {
    if (err.path) (acc as any)[err.path] = err.message;

    return acc;
  }, {});
};

// Validation helpers
const toNumberOrNull = (v: string) =>
  v ? (isNaN(Number(v)) ? null : Number(v)) : null;

export { type ErrorsType, getErrors, toNumberOrNull, yup };
